// dashboardWsMessage.js — 대시보드 WebSocket push 메시지 → setState 패치 변환.
//
// go-server(internal/scheduler/tasks.go pushWebSocket)는 최상위 envelope
//   { type: <event>, data: <payload> }
// 로 push 한다(레거시 Django Channels 의 { data: { data_type, data } } 와 다름).
// 과거 프론트 핸들러가 중첩 message.data.data_type 을 읽어 모든 push 가 switch
// default 로 빠지며 값이 갱신되지 않았다 → 대시보드 자동 갱신 멈춤 (DAS-144).
//
// payload 형태(서버 기준):
//   balance_update        : 잔고 entries 배열
//   exchange_rate_update  : 환율 "숫자"(float) 또는 {exchange_rate, source} 객체(DAS-181,
//                           koreaexim TLS 실패 시 upbit_usdt 폴백 출처 노출). REST(fetchExchangeRate)도
//                           같은 객체 형태이므로 둘 다 수용한다.
//   current_ratio_update  : { "strategy:fiat-risky": {...} } 맵(객체). 캐시 미스 시 빈 객체({})가
//                           올 수 있는데(DAS-181), 그대로 패치하면 화면의 게이지가 통째로 사라지므로
//                           빈 객체는 패치를 생략해 기존 값을 유지한다.

/**
 * WS 메시지를 대시보드 state 패치로 변환. 인식 못 하면 빈 객체.
 * @param {{type?:string, data?:any}} message
 * @returns {{balanceInfo?:Array, exchangeRate?:number, exchangeRateSource?:string, currentRatio?:object}}
 */
export function wsMessageToState(message) {
    const patch = {};
    if (!message || typeof message !== "object") return patch;
    const payload = message.data;
    switch (message.type) {
        case "balance_update":
            if (Array.isArray(payload)) patch.balanceInfo = payload;
            break;
        case "exchange_rate_update": {
            const rate =
                typeof payload === "number" ? payload : payload?.exchange_rate;
            if (rate != null && Number.isFinite(Number(rate))) {
                patch.exchangeRate = Number(rate);
            }
            const source =
                payload && typeof payload === "object" ? payload.source : undefined;
            if (typeof source === "string") {
                patch.exchangeRateSource = source;
            }
            break;
        }
        case "current_ratio_update":
            if (
                payload &&
                typeof payload === "object" &&
                !Array.isArray(payload) &&
                Object.keys(payload).length > 0
            ) {
                patch.currentRatio = payload;
            }
            break;
        default:
            break;
    }
    return patch;
}
